/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-config.js to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.REACT_APP_SITECORE_API_KEY || "391D75C6-01EE-463C-8B51-47B2748F8ACD",
config.sitecoreApiHost = process.env.REACT_APP_SITECORE_API_HOST || "https://prod-lvm.imcmvdp.com",
config.sitecoreSiteName = process.env.REACT_APP_SITECORE_SITE_NAME || "las-vegas-market",
config.graphQLEndpointPath = process.env.REACT_APP_GRAPH_QL_ENDPOINT_PATH || "/api/las-vegas-market",
config.defaultLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
config.graphQLEndpoint = process.env.REACT_APP_GRAPH_QL_ENDPOINT || "https://prod-lvm.imcmvdp.com/api/las-vegas-market",
config.layoutServiceConfigurationName = process.env.REACT_APP_LAYOUT_SERVICE_CONFIGURATION_NAME || "sxa-jss",
config.gtmEnvironmentName = process.env.REACT_APP_GTM_ENVIRONMENT_NAME || "prod",
config.configurationName = process.env.REACT_APP_CONFIGURATION_NAME || "sxa-jss",
config.environmentName = process.env.REACT_APP_ENVIRONMENT_NAME || "PROD",
module.exports = config;